import React from 'react';
import { Hospital } from '../../types/hospital.types';

interface HospitalHeaderProps {
  hospital: Hospital;
  isEditing: boolean;
  isSaving: boolean;
  isExpanded: boolean;
  hasChanges: boolean;
  onToggleEdit: () => void;
}

const HospitalHeader: React.FC<HospitalHeaderProps> = ({
  hospital,
  isEditing,
  isSaving,
  isExpanded,
  hasChanges,
  onToggleEdit
}) => {
  return (
    <>
      <div className="hospital-info">
        <h3 className="hospital-name">{hospital.name}</h3>
        <div className="hospital-address">
          {hospital.address}
        </div>
        <div className="hospital-badges">
          {hospital.isDeleted && (
            <span className="badge badge-deleted">
              Deleted
            </span>
          )}
          <span className={`badge ${hospital.isEsic ? 'badge-esic' : 'badge-non-esic'}`}>
            {hospital.isEsic ? 'ESIC' : 'Non-ESIC'}
          </span>
          <span className={`badge ${hospital.handleEmergency ? 'badge-emergency' : 'badge-regular'}`}>
            {hospital.handleEmergency ? 'Emergency' : 'Regular'}
          </span>
        </div>
        <div className="insurance-preview">
          <strong>Insurance:</strong> {hospital.insuranceList.length > 0 ? Array.from(new Set(hospital.insuranceList.map(ins => ins.nameOfInsurer))).join(', ') : 'None'}
        </div>
      </div>
      <div className="card-actions">
        <button
          className={`btn-edit ${isEditing ? 'editing-active' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onToggleEdit();
          }}
          disabled={isSaving || (isEditing && !hasChanges)}
        >
          {isSaving ? '⏳ Saving...' : isEditing ? '💾 Save' : '✏️ Edit'}
        </button>
        <span className="expand-icon">
          {isExpanded ? '▲' : '▼'}
        </span>
      </div>
    </>
  );
};

export default HospitalHeader;